/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ScriptStepStatusType } from './ScriptStepStatusType.js';
import {
    ScriptStepStatusTypeFromJSON,
    ScriptStepStatusTypeFromJSONTyped,
    ScriptStepStatusTypeToJSON,
} from './ScriptStepStatusType.js';

/**
 * 
 * @export
 * @interface ScriptStepStatus
 */
export interface ScriptStepStatus {
    /**
     * 
     * @type {number}
     * @memberof ScriptStepStatus
     */
    contactId?: number;
    /**
     * 
     * @type {number}
     * @memberof ScriptStepStatus
     */
    stepId?: number;
    /**
     * 
     * @type {ScriptStepStatusType}
     * @memberof ScriptStepStatus
     */
    status?: ScriptStepStatusType;
    /**
     * 
     * @type {Date}
     * @memberof ScriptStepStatus
     */
    dateCreated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ScriptStepStatus
     */
    dateUpdated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ScriptStepStatus
     */
    dateCompleted?: Date;
}

/**
 * Check if a given object implements the ScriptStepStatus interface.
 */
export function instanceOfScriptStepStatus(value: object): boolean {
    return true;
}

export function ScriptStepStatusFromJSON(json: any): ScriptStepStatus {
    return ScriptStepStatusFromJSONTyped(json, false);
}

export function ScriptStepStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScriptStepStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'contactId': json['contactId'] == null ? undefined : json['contactId'],
        'stepId': json['stepId'] == null ? undefined : json['stepId'],
        'status': json['status'] == null ? undefined : ScriptStepStatusTypeFromJSON(json['status']),
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateUpdated': json['dateUpdated'] == null ? undefined : (new Date(json['dateUpdated'])),
        'dateCompleted': json['dateCompleted'] == null ? undefined : (new Date(json['dateCompleted'])),
    };
}

export function ScriptStepStatusToJSON(value?: ScriptStepStatus | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contactId': value['contactId'],
        'stepId': value['stepId'],
        'status': ScriptStepStatusTypeToJSON(value['status']),
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateUpdated': value['dateUpdated'] == null ? undefined : ((value['dateUpdated']).toISOString()),
        'dateCompleted': value['dateCompleted'] == null ? undefined : ((value['dateCompleted'] as any).toISOString()),
    };
}

